/* eslint-disable no-unused-vars */
export enum MODEL_AUTH {
  apiKey = "b794936c1e8b40e5b330d4289abf0d9a",
  productId = "279624027",
  // 没用到
  skillId = "",
  skillVersion = "",
  basename = "/articles",
}
